import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { useLang } from '../i18n';
import { publicApi, resolveImage } from '../api';
import { useFetch } from '../useFetch';

export default function Story() {
  const loc = useLocation();
  const slug = loc.pathname.split('/').filter(Boolean)[0];
  const { lang, t } = useLang();
  const nav = useNavigate();
  const { data: city } = useFetch(`city:${slug}`, () => publicApi.city(slug), [slug]);
  const { data: story, loading } = useFetch(`story:${slug}`, () => publicApi.story(slug), [slug]);

  if (loading || !city || !story) return <div className="flex justify-center py-32"><Loader2 className="animate-spin text-gray-400" size={40} /></div>;

  const paragraphs = story.paragraphs?.[lang] || story.paragraphs?.en || [];

  return (
    <div>
      <section className="relative" style={{ minHeight: '45vh' }}>
        <div className="absolute inset-0"><img src={resolveImage(story.hero)} alt="" className="w-full h-full object-cover" /><div className="absolute inset-0 bg-black/50" /></div>
        <div className="relative z-10 flex flex-col items-center justify-center text-white text-center px-6" style={{ minHeight: '45vh' }}>
          <p className="text-sm tracking-widest uppercase opacity-90 fade-in-up">{city.full_name?.[lang] || city.name}</p>
          <h1 className="mt-2 text-3xl md:text-5xl font-bold tracking-wider fade-in-up fade-in-up-delay-1 tagline-display">{story.title?.[lang] || story.title?.en}</h1>
        </div>
      </section>
      <section className="max-w-3xl mx-auto px-6 py-16">
        <article className="prose prose-lg max-w-none">
          {paragraphs.map((p, i) => (
            <p key={i} className="text-gray-700 leading-relaxed mb-6 text-lg fade-in-up" style={{ animationDelay: `${0.05 + i * 0.08}s` }}>
              {i === 0 && <span className="float-left font-display text-6xl leading-[0.8] pr-3 pt-1 text-[color:var(--yup-primary)]">{p.charAt(0)}</span>}
              {i === 0 ? p.slice(1) : p}
            </p>
          ))}
        </article>
        <div className="mt-12 text-center">
          <button onClick={() => nav(`/${slug}`)} className="inline-flex items-center gap-2 text-[color:var(--yup-primary)] font-semibold hover:underline"><ArrowLeft size={16} /> {city.full_name?.[lang] || city.name}</button>
        </div>
      </section>
    </div>
  );
}
